import { Image } from "semantic-ui-react";

import Flex from "../../../../components/Flex/Flex";

import themeColors from "../../constants/themeColors";

export default function ImageAvatarNew({ abbr, src, size = 40, style, ...props }) {
	if (!src) {
		return (
			<Flex
				style={{
					justifyContent: "center",
					color: themeColors.WHITE,
					backgroundColor: "#CFCFCF",
					width: size,
					height: size,
					borderRadius: "50%",
					...style,
				}}
			>
				<p style={{ fontSize: size * 0.5 }}>{abbr}</p>
			</Flex>
		);
	}

	return <Image src={src} style={{ margin: 0, height: size, width: size, ...style }} avatar {...props} />;
}
